const baseUrl = '/rest/gongye/saas';
import Vue from 'vue';
// let Vue.http = Vue.http;

const api = {
  //-----------------------  子账号管理  -----------------------//
  obtainIndustryEnterprise(data) {
    //上游企业列表
    return Vue.http.post(`${baseUrl}/project/obtainCsoEnterprise`, data);
  },
  subaccountManagementList(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/List`, data);
  },
  subaccountManagementRoleList(data) {
    data.type = 1;
    return Vue.http.post(`${baseUrl}/subaccountManagement/roleList`, data);
  },
  roleAddOrEdit(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/roleAddOrEdit`, data);
  },
  roleDelete(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/roleDelete`, data);
  },
  status(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/status`, data);
  },
  theNewAccountOrEdit(data) {
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/theNewAccountOrEdit`,
      data
    );
  },
  logout(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/logout`, data);
  },
  cancelLogout(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/cancelLogout`, data);
  },
  queryLimitsOfAuthority(data) {
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/queryLimitsOfAuthority`,
      data
    );
  },
  userProjectQuery(data) {
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/userProjectQuery`,
      data
    );
  },
  userProjectAddOrEdit(data) {
    console.log(data);
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/userProjectAddOrEdit`,
      data,
      {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      }
    );
  },
  userProjectQueryExtend(data) {
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/userProjectQueryExtend`,
      data
    );
  },
  //-----------------------  主账号管理  -----------------------//
  masterAccountManagementList(data) {
    return Vue.http.post(`${baseUrl}/masterAccount/get`, data);
  },
  masterAccountEditPassWD(data) {
    return Vue.http.post(`${baseUrl}/masterAccount/editPassWD`, data);
  },
  sendMessageCode(data) {
    return Vue.http.post(`${baseUrl}/user/sendMessageCode`, data);
  },
  sendMessageCodeForUpdatePwd(data) {
    return Vue.http.post(`${baseUrl}/user/sendMessageCodeForUpdatePwd`, data);
  },
  verifyImgCode: `${baseUrl}/user/verifyImgCode`,
  getVerification(data) {
    return Vue.http.post(
      `${baseUrl}/get/verification/imageJson?type=slide`,
      data
    );
  },
  //-----------------------  操作日志  -----------------------//
  operationLogList(data) {
    return Vue.http.post(`${baseUrl}/operationLog/getPageList`, data);
  },
  operationLogExport: `${baseUrl}/operationLog/export`,
  viewOperationLog(data) {
    return Vue.http.post(`${baseUrl}/operationLog/viewOperationLog`, data);
  },
  getLogDetail(data) {
    return Vue.http.post(`${baseUrl}/operationLog/getLogDetail`, data);
  },
  listLogType(data) {
    return Vue.http.post(`${baseUrl}/operationLog/listLogType`, data);
  }
};

export default api;
